// extracted by mini-css-extract-plugin
export default {"navbar":"Layout_navbar__G8NJt"};